export default "__VITE_ASSET__BOoXFcCb__"